import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { ProjectSupervisionView } from "./ui/project-supervision";

export const createProjectSupervisionView = (
  ...rest: RouteObject[]
): RouteObject => {
  return {
    path: `${routes.supervision.root()}`,
    element: createElement(ProjectSupervisionView),
    children: [...rest],
  };
};
